

export const ResetPassword = (model) => {
 
  return $.post('Account/ResetPassword', model)

}
export const ForceResetPassword=(model)=>{

   return $.post('Account/ForceResetPassword', model)

}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/ResetPassword.service.js